export default "__VITE_ASSET__BIsVd_$I__"